module.exports = __webpack_public_path__ + "static/img/thumb_4.8218d54.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menu/thumb_4.jpg
// module id = tjyR
// module chunks = 0